// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61')
];

export const server_loads = [];

export const dictionary = {
		"/(payment)": [54,[4]],
		"/mgmt": [6,[2]],
		"/mgmt/dashboard": [52,[2]],
		"/mgmt/profile": [53,[2]],
		"/mgmt/settings/accountCards": [17,[2,3]],
		"/mgmt/settings/accountCards/edit/[uuid]": [18,[2,3]],
		"/mgmt/settings/bankAccountCredentials/create/[konto]": [24,[2,3]],
		"/mgmt/settings/bankAccountCredentials/edit/[uuid]": [23,[2,3]],
		"/mgmt/settings/bankAccounts": [7,[2,3]],
		"/mgmt/settings/bankAccounts/create": [10,[2,3]],
		"/mgmt/settings/bankAccounts/edit/[uuid]": [8,[2,3]],
		"/mgmt/settings/bankAccounts/view/[uuid]": [9,[2,3]],
		"/mgmt/settings/carriers": [41,[2,3]],
		"/mgmt/settings/carriers/LBE/create": [43,[2,3]],
		"/mgmt/settings/carriers/LBE/edit/[uuid]": [42,[2,3]],
		"/mgmt/settings/carriers/LB/create": [45,[2,3]],
		"/mgmt/settings/carriers/LB/edit/[uuid]": [44,[2,3]],
		"/mgmt/settings/carriers/Router/create": [49,[2,3]],
		"/mgmt/settings/carriers/Router/edit/[uuid]": [48,[2,3]],
		"/mgmt/settings/carriers/SIP/create": [47,[2,3]],
		"/mgmt/settings/carriers/SIP/edit/[uuid]": [46,[2,3]],
		"/mgmt/settings/checkInvoice": [50,[2,3]],
		"/mgmt/settings/externalUsers": [29,[2,3]],
		"/mgmt/settings/externalUsers/create": [32,[2,3]],
		"/mgmt/settings/externalUsers/edit/[uuid]": [30,[2,3]],
		"/mgmt/settings/externalUsers/view/[uuid]": [31,[2,3]],
		"/mgmt/settings/global": [51,[2,3]],
		"/mgmt/settings/locations": [33,[2,3]],
		"/mgmt/settings/locations/create": [36,[2,3]],
		"/mgmt/settings/locations/edit/[uuid]": [34,[2,3]],
		"/mgmt/settings/locations/view/[uuid]": [35,[2,3]],
		"/mgmt/settings/paymentImport": [11,[2,3]],
		"/mgmt/settings/paymentImport/edit/[uuid]": [12,[2,3]],
		"/mgmt/settings/paymentJournal": [20,[2,3]],
		"/mgmt/settings/paymentJournal/edit/[uuid]": [21,[2,3]],
		"/mgmt/settings/paymentJournal/view/[uuid]": [22,[2,3]],
		"/mgmt/settings/paymentRelocate": [28,[2,3]],
		"/mgmt/settings/paymentReopen": [19,[2,3]],
		"/mgmt/settings/tariffs": [13,[2,3]],
		"/mgmt/settings/tariffs/create": [16,[2,3]],
		"/mgmt/settings/tariffs/edit/[uuid]": [14,[2,3]],
		"/mgmt/settings/tariffs/view/[uuid]": [15,[2,3]],
		"/mgmt/settings/users": [37,[2,3]],
		"/mgmt/settings/users/create": [40,[2,3]],
		"/mgmt/settings/users/edit/[uuid]": [38,[2,3]],
		"/mgmt/settings/users/view/[uuid]": [39,[2,3]],
		"/mgmt/settings/validLocs": [25,[2,3]],
		"/mgmt/settings/validLocs/create": [27,[2,3]],
		"/mgmt/settings/validLocs/edit/[uuid]": [26,[2,3]],
		"/(payment)/[[lang=lang]]/services/[l_terms=l_terms]": [57,[4,5]],
		"/(payment)/[[lang=lang]]/services/[l_privacy=l_privacy]": [61,[4,5]],
		"/(payment)/[[lang=lang]]/services/[l_imprint=l_imprint]": [58,[4,5]],
		"/(payment)/[[lang=lang]]/services/[l_contact=l_contact]": [59,[4,5]],
		"/(payment)/[[lang=lang]]/services/[l_confirmation=l_confirmation]": [60,[4,5]],
		"/(payment)/[[lang=lang]]/[l_relatives=l_relatives]": [55,[4,5]],
		"/(payment)/[[lang=lang]]/[l_facilities=l_facilities]": [56,[4,5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);